const angular = require('angular');

const { ReviewService } = require('./review.service');
const { reviewListComponentDefinition } = require('./review-list.component');
const { reviewComponentDefinition } = require('./review.component');

angular.module('wowApp.shop')
    .service('ReviewService', ReviewService)
    .component('wowReviewList', reviewListComponentDefinition)
    .component('wowReview', reviewComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/review/index.js